export default __webpack_public_path__ + "static/amenagement-galerie-dimensions-8390491d8e9ccc645c40ce18f2565556.png";